import React from 'react';

import Translation from '../../../store/internationalization-store.js'
import { FormControl, FormGroup, Form, Row, Col } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import LanguageSelector from "../../language_select.js";
import LanguageInterfaceSelector from "../../language_select.js";
import Select from 'react-select';


class FormattedMessage extends React.Component {
    constructor(props) {
        super();
        this.props = props;
    }

    render(){
        return <span>{Translation.get(this.props.id , this.props.defaultMessage)}</span>
    }
}

class Component extends React.Component {
    constructor(props) {
        super();
        this.props = props
        var printables = [{ name: "Snap", text:<FormattedMessage id={'328'} defaultMessage={'Snap'} />,},
            { name: "Flashcards", text: <FormattedMessage id={'324'} defaultMessage={'Flashcards'}/>},
            { name: "Vocab List", text: <FormattedMessage id={'329'} defaultMessage={'Vocab List'}/>},
            { name: "Dice", text: <FormattedMessage id={'326'} defaultMessage={'Dice'}/> },
            { name: "Word Search", text: <FormattedMessage id={'205'} defaultMessage={'Word Search'}/> }
        ]

        var levels = [{ name: "Level 1", text:<FormattedMessage id={'147'} defaultMessage={'Level One'} />,},
            { name: "Level 2", text: <FormattedMessage id={'148'} defaultMessage={'Level Two'}/>},
            { name: "Level 3", text: <FormattedMessage id={'149'} defaultMessage={'Level Three'}/>}
        ]


        if(sessionStorage.product == "huber" || sessionStorage.getItem("product") == "klett" ||
            sessionStorage.getItem('product') == "larousse" || sessionStorage.getItem('product') == "hodder" ||
            sessionStorage.getItem('product') == "cornelson") {

            printables = [
                { name: "Vocab List", text: <FormattedMessage id={'329'} defaultMessage={'Vocab List'}/>}]
        }
        this.options = printables.map(function (printable) {
            return { value: printable.name, label: printable.text }
        });
        this.levelOptions = levels.map(function (level) {
            return { value: level.name, label: level.text }
        });
        this.levelValue = this.levelOptions[0];
        this.value = this.options[0];
        this.props.data.printable = this.options[0].value;
        this.props.data.level = 1;
    }



    onSelect (e) {
            this.props.data.printable = e.value;
            this.value = e;
            this.setState({ value: e });
        }
    onSelectLevel (e) {
            var lvl = e.value;
            this.levelValue = e;
            if (lvl == "Level 1" ){
                this.props.data.level = 1;
            } else if (lvl == "Level 2"){
                this.props.data.level = 2;
            } else {
                this.props.data.level = 3;
            }
            this.setState({ levelValue: e });
        }
    handleSelectLanguage (language) {
        console.log(language)
            this.props.data.selectedLanguage = language;
            this.setState({selectedLanguage : language});
        }
    handleSelectInterfaceLanguage (language) {
        console.log(language)
            this.props.data.selectedInterfaceLanguage = language;
            this.setState({selectedInterfaceLanguage : language});
        }

    render () {



            if(sessionStorage.product == "huber" || sessionStorage.product == "pratstart" || sessionStorage.getItem('product') == "larousse") {
                return (
                    <div>
                        <Row>
                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'330'} defaultMessage={'Choose Printable'} /></Form.Label>
                                    <Select onChange={this.onSelect.bind(this)} options={this.options} value={this.value} noResultsText={<FormattedMessage id={"2011"} defaultMessage={"No Results Found"} />} placeholder={<FormattedMessage id={'892'} defaultMessage={'Select'} />} />
                                </FormGroup>
                            </Col>

                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'847'} defaultMessage={'Choose Language'} /></Form.Label>
                                    <LanguageSelector returnValue={this.handleSelectLanguage.bind(this)} disabledLanguages={['ht', 'ur', 'ko']} />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'2175'} defaultMessage={'Choose Support Language'} /></Form.Label>
                                    <LanguageInterfaceSelector returnValue={this.handleSelectInterfaceLanguage.bind(this)} disabledLanguages={['ht', 'ur', 'ko']} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="p-b-20"></Row>
                    </div>)

            } else if(this.value != undefined && this.value.value == "Word Search")
            {
                return (
                    <div>
                        <Row>
                            <Col sm={4}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'330'} defaultMessage={'Choose Printable'} /></Form.Label>
                                    <Select onChange={this.onSelect.bind(this)} options={this.options} value={this.value} noResultsText={<FormattedMessage id={"2011"} defaultMessage={"No Results Found"} />}
                                            placeholder={<FormattedMessage id={'892'} defaultMessage={'Select'} />} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'9999999'} defaultMessage={'Choose Level'} /></Form.Label>
                                    <Select onChange={this.onSelectLevel} options={this.levelOptions} value={this.levelValue} noResultsText={<FormattedMessage id={"2011"} defaultMessage={"No Results Found"} />}
                                            placeholder={<FormattedMessage id={'892'} defaultMessage={'Select'} />} />
                                </FormGroup>
                            </Col>
                            <Col sm={4}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'847'} defaultMessage={'Choose Language'} /></Form.Label>
                                    <LanguageSelector returnValue={this.handleSelectLanguage.bind(this)} disabledLanguages={['rj' , 'hz', 'hand','ja', 'ko' , 'prs', 'ps','fa','cn', 'ar', 'ht', 'ur', 'ko']} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="p-b-20"></Row>
                    </div>)
            }else {
                return (
                    <div>
                        <Row>
                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'330'} defaultMessage={'Choose Printable'} /></Form.Label>
                                    <Select onChange={this.onSelect.bind(this)} options={this.options} value={this.value} noResultsText={<FormattedMessage id={"2011"} defaultMessage={"No Results Found"} />}
                                            placeholder={<FormattedMessage id={'892'} defaultMessage={'Select'} />} />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="fg-line">
                                    <Form.Label className="fg-label"><FormattedMessage id={'847'} defaultMessage={'Choose Language'} /></Form.Label>
                                    <LanguageSelector returnValue={this.handleSelectLanguage.bind(this)} disabledLanguages={['ht', 'ur', 'ko']} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="p-b-20"></Row>
                    </div>)
            }
        }

}

export default {
    name: <FormattedMessage id={'330'} defaultMessage={'Printables'} />,
    title: null,
    onSubmit: function (done) {
        
        if(!this.props.data.selectedLanguage){
            return done(new Error(Translation.get('ui-902' ,'Please Select A Language' )));
        } else {
            return done()
        }
    },
    value: null,
    component: Component
}